import { useEffect, useState } from "react";
import { api, fmtDateTime, ROLE_LABELS, titleCase } from "@/lib/api";
import { PageHeader, Spinner } from "@/components/common/Primitives";

export default function AuditPage() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/audit").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Audit log" subtitle="Every write, login and impersonation is recorded per tenant" testId="audit-header" />
      {!rows ? <Spinner /> : (
        <div className="fv-card overflow-x-auto p-1" data-testid="audit-table">
          <table className="w-full text-left text-xs">
            <thead><tr className="fv-caption border-b">{["When", "User", "Role", "Action", "Entity", "Details"].map((h) => <th key={h} className="px-3 py-2 font-medium">{h}</th>)}</tr></thead>
            <tbody className="divide-y">
              {rows.map((a) => (
                <tr key={a.id} data-testid={`audit-row-${a.id}`} className="hover:bg-secondary/50">
                  <td className="whitespace-nowrap px-3 py-2 text-muted-foreground">{fmtDateTime(a.created_at)}</td>
                  <td className="whitespace-nowrap px-3 py-2 font-medium">{a.user_name || "System"}{a.impersonated_by && <span className="ml-1 rounded-full bg-[#FFF8E1] px-1.5 text-[10px] text-[#7A5600] dark:bg-[#3E2723] dark:text-[#FFD54F]">impersonated</span>}</td>
                  <td className="whitespace-nowrap px-3 py-2 text-muted-foreground">{ROLE_LABELS[a.role] || "—"}</td>
                  <td className="whitespace-nowrap px-3 py-2">{titleCase(a.action.replace(".", " "))}</td>
                  <td className="whitespace-nowrap px-3 py-2 text-muted-foreground">{a.entity_type}</td>
                  <td className="max-w-[320px] truncate px-3 py-2 text-muted-foreground">{Object.entries(a.meta || {}).map(([k, v]) => `${k}: ${v}`).join(" · ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
